module.exports = function getResource(label, vars = []) {
    const resources = { advertising: 'Publicité' };

    return resources[label];
};
